import GridContainer from '../components/GridContainer'
import Header from '../components/Header'
import logoVote from '../assets/images/vote-for-your-weekend.svg'
import Literal from "../literals/Literal"

const About = () => {
  return (
    <>
      <Header />
      <GridContainer>
        <div className="flex flex-col col-span-4 pb-2 sm:pb-4 md:col-start-2 md:col-span-3 sm:col-start-2 sm:col-span-2 md:py-10">
          <div className="self-center w-full max-w-md px-12 py-6 sm:px-4 md:px-0 md:py-0 md:self-start">
            <img src={logoVote} alt="VOTE YOUR WEEKEND" className="w-full"/>
          </div>
        </div>
        <div className="flex flex-col items-start justify-center col-span-4 col-start-1 text-md sm:text-lg md:text-xl md:col-start-2 md:col-span-9">
          <div className="pb-4 sm:pb-6 md:pb-12">{Literal('ABOUT_INTRO')}</div>
          <div>{Literal('ABOUT_MORE_INFO')} <a target='_blank' rel='noreferrer' href={Literal('ABOUT_MORE_INFO_URL')}>{Literal('ABOUT_MORE_INFO_URL')}</a></div>
        </div>
      </GridContainer>
    </>
  )
}

export default About